import { lazyRevealImages } from "./lazy-reveal-images"

const participants = document.querySelectorAll(".participant--has-modal")
const modal = document.querySelector(".participant-modal")

if (participants.length && modal) {
  const modalTitle = modal.querySelector(".participant-modal__title")
  const modalImage = modal.querySelector(".participant-modal__image")
  const modalContent = modal.querySelector(".participant-modal__content")
  const closeButton = modal.querySelector(".lightbox-close")

  const openModal = (participant, content, extraInfo, imageFigure) => {
    const title = participant.querySelector(".participant__title")

    modalTitle.innerHTML = title ? title.innerHTML : ""
    modalImage.innerHTML = imageFigure ? imageFigure.outerHTML : ""
    modalContent.innerHTML = content.innerHTML
    modal.classList.add("is-open")
    document.body.style.overflow = "hidden"
    lazyRevealImages()
  }

  const closeModal = () => {
    modal.classList.remove("is-open")
    document.body.style.overflow = ""
  }

  participants.forEach((participant) => {
    const content = participant.querySelector(".participant__content")

    if (!content) return

    const extraInfo = participant.querySelector(".participant__extra-info")
    const imageFigure = participant.querySelector(".participant__image")

    const trigger = () =>
      openModal(participant, content, extraInfo, imageFigure)

    participant.addEventListener("click", trigger)
    participant.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault()
        trigger()
      }
    })
  })

  closeButton?.addEventListener("click", closeModal)

  modal.addEventListener("click", (event) => {
    if (event.target === modal) {
      closeModal()
    }
  })

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && modal.classList.contains("is-open")) {
      closeModal()
    }
  })
}
